import EmptyPage from '../../empty-page/emptyPage';

const OrgActivityInsights = () => {
    return <EmptyPage />;
};

export default OrgActivityInsights;
